import React from "react";
import "../CSS/Contact.css";

const Contact = () => {
  const handleSubmit = () => {
    const name = prompt("Enter your full name:");
    if (!name) return;

    const email = prompt("Enter your email:");
    if (!email) return;

    const phone = prompt("Enter your phone number:");
    if (!phone) return;

    const message = prompt("Enter your message:");
    if (!message) return;

    const bodyContent = `
Dear Tour Adviser,

I hope this message finds you well. I am writing to inquire about your tour services. 
Please find my details below:

Name: ${name}
Email: ${email}
Phone: ${phone}

Message:
${message}

I would appreciate it if you could provide me with more information about your upcoming tours 
and any packages you offer.

Thank you for your assistance. Looking forward to your prompt response.

Best regards,
${name}
`;

    const mailtoLink = `mailto:seashorenanotech@gmail.com?subject=${encodeURIComponent(
      "Tour Information"
    )}&body=${encodeURIComponent(bodyContent)}`;

    window.location.href = mailtoLink;
  };

  const contacts = [
    {
      id: 1,
      icon: "bi bi-house-door",
      title: "Location",
      desc: (
        <a
          href="https://maps.app.goo.gl/YFK73wTcTjYNRVaNA"
          className="contact-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          LG 31, SKYMY TRAVEL CO.,LTD
          OPPOSITE KRISHNA MALL, STATION ROAD BARDOLI
        </a>
      ),
    },
    {
      id: 2,
      icon: "bi bi-telephone",
      title: "Phone",
      desc: (
        <a href="tel:66925528900" className="contact-link">
          +66925528900
          +919825380928
        </a>
      ),
    },
    {
      id: 3,
      icon: "bi bi-envelope",
      title: "Gmail",
      desc: (
        <span
          className="contact-link"
          onClick={handleSubmit}
          style={{ cursor: "pointer" }}
        >
          skymytravelthailand@gmail.com
        </span>
      ),
    },
    {
      id: 4,
      icon: "bi bi-chat-dots",
      title: "Chat",
      desc: (
        <div className="chat-icons">
          <a
            href="https://wa.me/66925528900?text=Hello%2C%20I%20am%20interested%20in%20your%20tour%20services.%20Can%20you%20please%20provide%20more%20information%3F"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi bi-whatsapp"></i>
          </a>
          {/* <a href="https://t.me/yourtelegramusername" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-telegram"></i>
          </a>
          <a href="#" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-messenger"></i>
          </a> */}
        </div>
      ),
    },
  ];

  return (
    <div className="contact-container">
      <div className="contact-hero-section">
        <h3 className="text-center"><b>Contact Us</b></h3>     
        <p className="text-center">We'd love to hear from you!</p>
      </div>
      <div className="contact-grid">
        {contacts.map((contact) => (
          <div className="contact-card" key={contact.id}>
            <i className={`${contact.icon} contact-icon`}></i>
            <h3>{contact.title}</h3>
            <p>{contact.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contact;
